import React from 'react'
import { withAllContexts } from '../AllContextsWrapper';
import { ChevronLeft, ChevronRight } from 'lucide-react';

class NavCalendar extends React.Component {

  changeMonth = (action) => {
    let navCalDate = new Date(this.props.app.state.navDate.date);
    navCalDate.setDate(navCalDate.getDate() + (+this.props.app.state.navDate.dim * action))
    this.props.app.functions.changeNavCalDate(this.props.app.functions.getDateObj(navCalDate), true);
  }


  render() {
    let actualDays = this.props.app.functions.actualDays(this.props.app.state.navDate);
    // let view = this.props.view;
    let fdi = this.props.app.functions.getFirstDayIndex(this.props.app.state.navDate);
    let days = [];

    for (let i = 0; i < this.props.app.functions.toShow(this.props.app.state.navDate, "month").days; i++) {
      let currDay = i + fdi;
      days.push(
        <NavCalendarDay
          {...this.props}
          key={i + "navCalendarDay"}
          date={actualDays[currDay]}
          today={this.props.today}
          holidays={this.props.app.functions.getHolidays(this.props.app.state.navDate)}
        />
      );
    }

    const dayNames = ['PO', 'UT', 'ST', 'ŠT', 'PI', 'SO', 'NE'];

    return (
      <div className="p-4 bg-white rounded-xl shadow-sm border border-gray-100 m-2">
        <div className="flex items-center justify-between mb-4 px-1">
          <h2 className="text-lg font-bold text-gray-800 capitalize">
            {this.props.app.state.navDate.date.toLocaleString('default', { month: 'long' })}&nbsp;
            {this.props.app.state.navDate.year}
          </h2>
          <div className="flex gap-1">
            <button
              onClick={() => this.changeMonth(-1)}
              className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={() => this.changeMonth(1)}
              className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-7 gap-1 mb-2">
          {dayNames.map(day => (
            <div key={day} className="text-[10px] font-bold text-gray-400 text-center py-1 uppercase tracking-wider">
              {day}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-1">
          {days}
        </div>

      </div>

    );
  }
}

class NavCalendarDay extends React.Component {

  changeDate = () => {
    let dateObj = this.props.app.functions.getDateObj(this.props.date.date);
    this.props.app.functions.changeCalDate(dateObj);
  }

  render() {
    let isToday = this.props.today.dateStr === this.props.date.dateStr;
    let isHoliday = this.props.app.functions.getHolidays(this.props.app.state.navDate).includes(this.props.date.dateStr);

    let baseClasses = "text-sm h-8 w-8 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-200 mx-auto select-none";
    let colorClasses = "text-gray-700 hover:bg-gray-50 hover:text-blue-600";

    if (isToday) {
      colorClasses = "bg-blue-600 text-white font-bold hover:bg-blue-700 shadow-md shadow-blue-200";
    } else if (isHoliday) {
      colorClasses = "text-red-500 font-medium hover:bg-red-50";
    }

    return (
      <div
        onClick={this.changeDate}
        className={`${baseClasses} ${colorClasses}`}
      >
        {this.props.date.day}
      </div>
    );
  }
}

export default withAllContexts(NavCalendar);
